import { render, staticRenderFns } from "./VerFacturaModal.vue?vue&type=template&id=6cc9c810&"
import script from "./VerFacturaModal.vue?vue&type=script&lang=ts&"
export * from "./VerFacturaModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerFacturaModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports